import Identifier from '../../core/Identifier';
import ActionText from '../../core/ActionText';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import AreYouSure from '../../core/AreYouSure';
import BasicReadField from '../../core/BasicReadField';
import { globalStyles as styles } from '../../core/style/gstheme';
import { ENTITLEMENTS } from '../../application-core/constants';
import { checkResourceEntitlements } from '../../core/utils/utils';
import ViewOnly from '../../core/ViewOnly';
import withGS from '../../core/withGShoc';
import { STATUS_ACCEPTED, STATUS_REJECTED } from '../../core/utils/constants';

const APPROVED = STATUS_ACCEPTED;
const REJECTED = STATUS_REJECTED;

class LabelSummaryDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            areYouSure: false
        };
    }

    checkIfSure = () => this.setState({ areYouSure: true });

    onSure = () => {
        this.setState({ areYouSure: false });
        const { data } = this.props;
        const { literalForm } = data;
        const lang = Object.keys(literalForm)[0];
        const isXlLabelOf = data.isXlPrefLabelOf || data.isXlAltLabelOf || data.isXlHiddenLabelOf || null;
        const isXlLabelOfProperty = (data.isXlPrefLabelOf && "prefLabel") || (data.isXlAltLabelOf && "altLabel") || (data.isXlHiddenLabelOf && "hiddenLabel") || null;
        this.props.onDeleteLabel(this.props.id, isXlLabelOf, literalForm[lang], lang, isXlLabelOfProperty);
    };

    onNotSure = () => this.setState({ areYouSure: false });

    render() {

        const { areYouSure } = this.state;
        const { data, classes, id, allowIRIchange, schemeIRI, graph, project, useWorkflow } = this.props;

        if (data._notAvailable) return <div>
            <BasicReadField margin="dense" text={id} fullWidth />
            <ActionText offset="30px">This resource is not available. It may have been deleted.</ActionText>
        </div>;

        const { literalForm } = data;

        const isApproved = useWorkflow && "status" in data && data.status[0] === APPROVED ? true : false;
        const isRejected = useWorkflow && "status" in data && data.status[0] === REJECTED ? true : false;

        const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_TAXONOMY) || isApproved;

        if (!literalForm) return null;
        const lang = Object.keys(literalForm)[0];
        const isXlLabelOf = data.isXlPrefLabelOf || data.isXlAltLabelOf || data.isXlHiddenLabelOf || null;
        if (data.pendingReplacement) return null;

        const currentIRI = data.iri && data.iri.length > 0 ?
            data.iri[data.iri.length - 1]
            :
            data.id;

        return (
            <div>
                <form autoComplete="off">
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={9}>
                            <Typography data-test="label-heading"
                                variant="h6"
                                style={{ wordBreak: 'break-word' }}
                                className={classes.mainHeading}>
                                {
                                    literalForm[lang] ? literalForm[lang] : ""}{(isReadOnly || isRejected) && <ViewOnly />
                                }
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={3} style={{ textAlign: 'right' }}>
                            {!isReadOnly &&
                                <Tooltip data-test="delete-resource" placement="right" title='Delete label'>
                                    <IconButton size="small" onClick={this.checkIfSure} className={classes.deleteButton}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <Identifier
                                dataTest="identifier"
                                type="Label"
                                project={project}
                                isReadOnly={isReadOnly || isRejected || !allowIRIchange}
                                currentIRI={currentIRI}
                                identifier={id}
                                graph={graph}
                                baseIRI={schemeIRI} />
                        </Grid>
                    </Grid>
                </form>
                {areYouSure && <AreYouSure
                    onSure={this.onSure}
                    onNotSure={this.onNotSure}
                    message={isXlLabelOf ?
                        [
                            "Do you really want to delete this label?",
                            "This label is used by a concept and deleting will remove the label from that concept (unless it is a preferred label in the default language in which case it will be converted to a normal label).",
                            "Note: Deleted item IRIs will not be available for reuse for a few minutes."
                        ]
                        :
                        [
                            "Do you really want to delete this label?",
                            "Note: Deleted item IRIs will not be available for reuse for a few minutes."
                        ]}
                />}
            </div>
        );
    }
}

LabelSummaryDetail.propTypes = {
    classes: PropTypes.object,
    schemeIRI: PropTypes.string,
    allowIRIchange: PropTypes.bool,
    project: PropTypes.string,
    useWorkflow: PropTypes.bool,
    onDeleteLabel: PropTypes.func,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
};

export default withStyles(styles)(withGS(LabelSummaryDetail, ["ALL"], null, {}, true));
